export function RentalStatusDisplay(props) {
	let insp = props.inspection;

	if(!insp.rentalMode) { return ""; }
	if(insp.rentalDisposition == "CHECK_IN") {
		return <span className="text-success">(IN)</span>;
	}
	if(insp.rentalDisposition == "CHECK_OUT") {
		return <span className="text-warning">(OUT)</span>;
	}
	return null;
}